import { WebSocketLink } from "@apollo/client/link/ws";
import { createHttpLink, split } from "@apollo/client";

import { getMainDefinition } from "@apollo/client/utilities";
import { SubscriptionClient } from "subscriptions-transport-ws";
import { getUser } from "../utils/tokens";
import { addSeconds } from "date-fns";
import { dedupedRefresh } from "./dedupedRefresh";
import { initDatadogRum } from "@notemeal/reporting/datadog-rum";

initDatadogRum({
  applicationId: "44bdbca4-8dcf-42b7-b844-102aa58eefbe",
  clientToken: "pub88d883e6b6b4db3d43e5bc9202ef7c52",
  service: "notemeal-web",
  version: process.env.REACT_APP_COMMIT_HASH,
  env: process.env.NODE_ENV,
  sessionReplaySampleRate: 100,
});

const wsUrl = process.env.REACT_APP_GRAPHQL_API_URL.replace("https", "wss").replace("http", "ws");

export const wsClient = new SubscriptionClient(wsUrl, {
  reconnect: true,
  lazy: true,
  timeout: 45000,
  inactivityTimeout: 1000,
  connectionParams: async () => {
    const accessToken = getUser();
    if (!accessToken || new Date(accessToken.exp * 1000) < addSeconds(new Date(), 15)) {
      const result = await dedupedRefresh();
      if (result) {
        return {
          jwtToken: result.data.accessToken,
        };
      }
    }
  },
});

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_API_URL,
  credentials: "include",

  headers: {
    "x-notemeal-web-schema-version": process.env.REACT_APP_WEB_SCHEMA_VERSION,
  },
});

const wsLink = new WebSocketLink(wsClient);

export const apiLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === "OperationDefinition" && definition.operation === "subscription";
  },
  wsLink,
  httpLink
);
